var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    clipPath: "url(#clip0_56_29787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2222 7.67833V5.45611C14.2222 4.86674 13.9881 4.30151 13.5713 3.88476C13.1546 3.46801 12.5893 3.23389 12 3.23389H4.22222C3.63285 3.23389 3.06762 3.46801 2.65087 3.88476C2.23413 4.30151 2 4.86674 2 5.45611V18.7894C2 19.3788 2.23413 19.944 2.65087 20.3608C3.06762 20.7775 3.63285 21.0117 4.22222 21.0117H12C12.5893 21.0117 13.1546 20.7775 13.5713 20.3608C13.9881 19.944 14.2222 19.3788 14.2222 18.7894V16.5672",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.66797 12.1224H22.0013L18.6679 8.78906",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.668 15.4559L22.0013 12.1226",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_29787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.122559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.c198159e70dd261bae7ab786bdf3e346.svg";
export { ForwardRef as ReactComponent };